// {feed}/partner.json (P2, §12.5): só o contrato, para o JSON Schema de §14.10. O PartnerSlot nasce na
// Fase 15, atrás de features.partner_slots (desligada; bloqueada em 25/10).
import * as z from 'zod/mini';
import { IntSchema, type Iso, IsoSchema } from './base';

export interface PartnerConfig {
  schema: 'ops.partner';
  schema_version: 1;
  /** Kill switch remoto. */
  enabled: boolean;
  /** Campanha. */
  id: string;
  /** Rótulo em texto, obrigatório. */
  label: 'Anúncio' | 'Parceiro';
  valid_from: Iso;
  valid_until: Iso;
  /** card: 0 a 3 peças. */
  slots: { bar: PartnerPiece | null; card: PartnerPiece[] };
}
export interface PartnerPiece {
  id: string;
  sponsor_name: string;
  /** https, link externo. */
  href: string;
  /** Até 80 caracteres. */
  text?: string;
  /** Servida pela mesma origem do feed. */
  image?: { src: string; width: number; height: number; alt: string };
}

const PieceSchema = z.object({
  id: z.string(),
  sponsor_name: z.string(),
  href: z.string().check(z.regex(/^https:\/\//)),
  text: z.optional(z.string().check(z.maxLength(80))),
  image: z.optional(z.object({ src: z.string(), width: IntSchema, height: IntSchema, alt: z.string() })),
});

export const PartnerConfigSchema = z.object({
  schema: z.literal('ops.partner'),
  schema_version: z.literal(1),
  enabled: z.boolean(),
  id: z.string(),
  label: z.enum(['Anúncio', 'Parceiro']),
  valid_from: IsoSchema,
  valid_until: IsoSchema,
  slots: z.object({ bar: z.nullable(PieceSchema), card: z.array(PieceSchema).check(z.maxLength(3)) }),
});
